<template>
    <div>
        <div id="legend" class="legend">
            <h3>Map Legend</h3>
            <div v-for="item in legendItems" :key="item.id" class="legend-item">
                <span
                    class="legend-color"
                    :style="{ backgroundColor: item.color }"
                ></span>
                <span class="legend-label">{{ item.label }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import { getOgcStyleJson } from '../../../../services/map/layer/ogcapi';
    export default {
        name: 'legend-style-ogct',

        props: {
            styleServiceUrl: { type: String, required: true },
            styleId: { type: String, required: true }
        },
        data() {
            return {
                styleJson: {},
                legendItems: []
            };
        },

        computed: {
            combinedProps() {
                // Combine two properties so we can add 1 watch for both.
                return { url: this.styleServiceUrl, id: this.styleId };
            }
        },
        methods: {
            async $_getStyleJson() {
                this.styleJson = await getOgcStyleJson(
                    this.$store,
                    this.styleServiceUrl,
                    this.styleId
                );
            },

            async $_generateLegend() {
                // Extract layers with color properties and store them in `legendItems`
                this.legendItems = this.styleJson.layers
                    .filter(
                        (layer) =>
                            layer.paint &&
                            (layer.paint['fill-color'] ||
                                layer.paint['line-color'] ||
                                layer.paint['circle-color'])
                    )
                    .map((layer) => {
                        const color =
                            layer.paint['fill-color'] ||
                            layer.paint['line-color'] ||
                            layer.paint['circle-color'];
                        return {
                            id: layer.id,
                            color,
                            label: layer.id // Set label based on layer ID or modify as needed
                        };
                    });
            }
        },
        watch: {
            combinedProps: {
                async handler() {
                    // This function runs whenever styleServiceUrl or styleId changes
                    await this.$_getStyleJson();
                    await this.$_generateLegend();
                },
                immediate: true // run immediately on component mount
            }
        }
    };
</script>

<style>
.legend {
    padding: 10px;
    background: white;
    border-radius: 5px;
    max-width: 200px;
}
.legend h3 {
    margin-top: 0;
}
.legend-item {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
}
.legend-color {
    width: 20px;
    height: 20px;
    margin-right: 10px;
}
.legend-label {
    font-size: 14px;
}
</style>
